import React from 'react';

import { Trans } from 'react-i18next';

import { SmallTitle } from '../../../components/Base/Title';
import BannerSkeleton from '../../../components/Base/Banner/BannerSkeleton';
import OrderDetailSkeleton from '../../../components/Order/Detail/OrderDetailSkeleton';

const SummarySkeleton = () => (
  <>
    <BannerSkeleton />
    <div className="basket container container--full container--blue">
      <div className="container container--padding">
        <SmallTitle className={'basket__title'}>
          <Trans>session-summary.basket.title</Trans>
        </SmallTitle>
        <div className="basket__block basket__block--cart">
          <OrderDetailSkeleton />
        </div>
      </div>
    </div>
  </>
);

export default SummarySkeleton;
